// import SDK from "public@sdk/index";
class Action {
  // private sdk: any;
  private store: any;
  // private timeOut: any;

  constructor(store: any) {
    this.store = store;
    // this.sdk = SDK;
  }

  public onAddPraiseCount = () => {
    this.store.praiseCount += 1;
  };

  public changePlaybackTarget = (index: number) => {
    this.store.playbackIndex = index;
    if (!this.store.isPlayerBack) {
      this.beginLivePlayback(index);
    }
  };

  // 判断内外网

  public beginLivePlayback = async (index: number) => {
    this.store.playbackIndex = index;
    const { livePlaybackPath, beginLivePlayback } = this.store;
    const src = livePlaybackPath.vodInnerUrls[index];
    // const result: boolean = await this.sdk.TESTInsideAndOutsideNet(src);

    // const result: any = await this.handleVideoPath(src);
    // console.log('result', result)
    // if (result) {
    //   this.store.playBackArray = livePlaybackPath.vodInnerUrls;
    // } else {
    //   this.store.playBackArray = livePlaybackPath.vodOuterUrls;
    // }

    try {
      console.log("vodInnerUrls");
      await this.handleVideoPath(src);
      this.store.playBackArray = livePlaybackPath.vodInnerUrls;
    } catch (e) {
      console.log("vodOuterUrls");
      this.store.playBackArray = livePlaybackPath.vodOuterUrls;
    }
    beginLivePlayback(index);
  };

  public handleVideoPath = async (src: string) => {
    return new Promise((resolve, reject) => {
      const video = document.createElement("video");
      const source = document.createElement("source");
      source.setAttribute("src", src);
      video.append(source);
      video.load();

      video.oncanplaythrough = () => {
        resolve(true);
      };

      setTimeout(() => {
        reject(false);
      }, 500);
    });
  };

  public onMessageInput = (txt: string) => {
    this.store.onMessageInput(txt);
  };

  public onMessageEmoji = (emoji: string) => {
    this.store.messageValue += emoji;
  };

  public onUserInputInfo = (value: string, target: string) => {
    this.store.userInputValues[target] = value;
  };

  public onFocusInput = (target: string) => {
    const dom = document.querySelector(`#${target}`) as HTMLElement;
    dom.classList.remove("input__error");
  };

  public onChangeRadio = (value: boolean) => {
    this.store.userInputValues.gender = value;
  };

  public onColumnTarget = (value: string) => {
    this.store.columnTarget = value;
  };

  // public onloadBye = (liveId: string) => {
  //   this.sdk.onloadBye(liveId);
  // };

  public submitInfoVerify = (e: string) => {
    const { userInputValues } = this.store;
    const target =
      userInputValues[e] === undefined ? userInputValues[e] : userInputValues[e].trim();

    // if ( e === 'name' && target.length > 15) {
    //     this.verifyAddHint(e);
    //   }

    switch (target) {
      case "":
      case undefined: {
        this.verifyAddHint(e);
        this.store.inputVerify = false;
        break;
      }
    }

    switch (e) {
      case "mobile": {
        if (!/0?(10|11|12|13|14|15|16|17|18|19|)[0-9]{9}/.test(target)) {
          this.verifyAddHint(e);
          this.store.inputVerify = false;
        }
        break;
      }

      case "email": {
        if (!/\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/.test(target)) {
          this.verifyAddHint(e);
          this.store.inputVerify = false;
          return;
        }
        break;
      }
    }
  };

  public verifyAddHint = (target: string) => {
    const dom = document.querySelector(`#${target}`) as HTMLElement;
    dom.classList.add("input__error");
  };
}

export default Action;



// WEBPACK FOOTER //
// ./src/publics/action/index.ts